<template>
  <div class="meeting-schedule-dialog">
    <el-dialog
      title="选定议程"
      :visible="visible"
      :before-close="beforeCloseHandler"
    >
      <div class="select-wrapper">
        <div class="left">
          <el-table
            :data="meetingBillList"
            border
            width="200"
            max-height="300"
            ref="billTableRef"
            @selection-change="handleSelectionChange"
          >
            <el-table-column type="selection" width="50"> </el-table-column>
            <el-table-column
              type="index"
              width="50"
              label="序号"
            ></el-table-column>
            <el-table-column label="议题" prop="title" show-overflow-tooltip></el-table-column>
            <el-table-column label="汇报人" prop="reportUserName" show-overflow-tooltip></el-table-column>
            <el-table-column label="参会部门" show-overflow-tooltip>
              <template slot-scope="scope">
                <span v-for="item in scope.row.checkWorkList" :key="item.id">
                  {{item.name}}&nbsp;
                </span>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="middle">
          <el-button type="primary" @click="createSchedule">添加议程 <i class="el-icon-d-arrow-right"></i></el-button>
          <el-button type="primary" @click="autoCreateSchedule">自动生成议程 <i class="el-icon-d-arrow-right"></i></el-button>
        </div>
        <div class="right">
          <el-table
            :data="scheduelList"
            border
            width="200"
            max-height="300"
          >
            <el-table-column
              type="index"
              width="50"
              label="序号"
            ></el-table-column>
            <el-table-column label="主题">
              <template slot-scope="scope">
                <div class="theme-item" v-for="item in scope.row.bills" :key="item.id">
                  <el-input v-model="item.theme" placeholder="-请输入-"></el-input>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="80">
              <template slot-scope="scope">
                <el-button type="text" size="mini" @click="removeSchedule(scope.row)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <div slot="footer">
        <el-button @click="closeDialog" type="info">取消</el-button>
        <el-button type="primary" @click="submitDialog">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { v4 as uuidv4 } from 'uuid';
import Constants from '@/utils/consts';
import _ from "lodash"
export default {
  name: "MeetingScheduleDialog",
  props: {
    meetingBillList: {
      // 上一步选定的提报单列表，在这里用来组合出会议议程
      type: Array,
      default: () => [],
    },
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      scheduelList: [],
      currentSelectedBills: [], // 当前选中的提报单，要操作他们
    };
  },
  methods: {
    // ------------- 生命周期方法
    beforeCloseHandler(done) {
      done();
      this.$emit("submit");
    },
    submitDialog() {
      let can = true
      let data = this.scheduelList;
      for(let i=0;i<data.length;i++) {
        if(!can) {
          break
        }
        let bills = data[i].bills
        for(let j=0;j<bills.length;j++) {
          if(!bills[j].theme) {
            can = false
            break
          }
        }
      }
      if(!can) {
        this.$message.warning("请填写主题");
        return
      }
      this.$emit("submit", _.cloneDeep(data));
      this.scheduelList = []; // submit之后清空一下
    },
    closeDialog() {
      this.$emit("submit");
    },
    // ---------------- 功能逻辑方法
    handleSelectionChange(val) {
      this.currentSelectedBills = val;
    },
    createSchedule() {
      //手动添加议程
      if (!this.currentSelectedBills || this.currentSelectedBills.length == 0) {
        this.$alert(Constants.No_Select_Tip, '提示');
        return;
      }

      let used = false;
      this.currentSelectedBills.forEach(item => {
        let index = this.scheduelList.findIndex(schedule => (schedule.bills.indexOf(item) != -1));
        if (index != -1) {
          used = true;
          return;
        }
      });
      if (used) {
        this.$alert('请不要重复使用提报单生成议程', '提示');
        return;
      }
      // 到这里，选定的提报单没有被重复使用
      // 将选定的议题合并成一个议程对象
      this.currentSelectedBills.forEach(item => {
        this.$set(item, 'theme', item.title);// 将主题和议题分开，主题默认是跟议题一样，但后续就是两个东西
      })

      console.log('---', this.currentSelectedBills);

      let scheduleVO = {
        id: uuidv4(),
        bills: [...this.currentSelectedBills],
      }
      this.scheduelList.push(scheduleVO);
      this.$refs.billTableRef.clearSelection(); // 手动合成议程后，清空选择
    },
    autoCreateSchedule() {
      // 自动生成议程
      this.$confirm('自动生成议程将会删除已选定的议程，您确定继续吗？', '提示', {
        confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
      }).then(() => {
        this.scheduelList = [];
        // 然后按照规则自动生成议程
        let obj = {};
        for(let i=0;i<this.meetingBillList.length;i++) {
          let item = this.meetingBillList[i];
          
          this.$set(item, 'theme', item.title);
          let { checkWorkList } = item;
          let ids = [];
          checkWorkList.forEach(o => ids.push(o.id));
          ids.sort();
          ids = ids.join(",");
          // console.log('ids:', ids);
          this.$set(item, 'checkWorkListIds', ids);
          if (obj[ids]) {
            obj[ids].push(item);
          } else {
            obj[ids] = [item];
          }
        }
        
        for(let key in obj) {
          let vo = {
            id: uuidv4(),
            bills: [...obj[key]],
          }
          this.scheduelList.push(vo);
        }

        // console.log('自动生成的list', this.scheduelList);

      }).catch(() => {});
    },
    removeSchedule(row) {
      let index = this.scheduelList.findIndex(item => item.id == row.id);
      if (index != -1) {
        this.scheduelList.splice(index, 1);
      }
    }
  },
};
</script>

<style lang="scss" scoped>

/deep/.el-dialog {
  width: 1200px !important;
}

.select-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}

.left,
.right {
  width: 400px;
  height: 100%;
}

.middle {
  width: 200px;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  .el-button + .el-button {
    margin-top: 20px;
  }
}

.theme-item + .theme-item {
  margin-top: 3px;
}
</style>
